var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"consultation-form--wrapper"},[_c('keep-alive',[_c(_vm.form,{ref:"form",tag:"component",attrs:{"formdata":_vm.formdata,"actions":_vm.actions},on:{"submit":_vm.next,"prev":_vm.prev,"cancel":_vm.cancel}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }